import { render, staticRenderFns } from "./BookingFormEdit.vue?vue&type=template&id=842e8af6&"
import script from "./BookingFormEdit.vue?vue&type=script&lang=js&"
export * from "./BookingFormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports